"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const extractParamWithEntryVar_1 = __importDefault(require("../shared/extractParamWithEntryVar"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const entryVarEvaluatorContextInputData = async ({ processor, entryVar, evaluateEntryVar, }) => {
    var _a, _b, _c, _d;
    const params = (entryVar.source === 'appRuntimeData')
        ? processor.root.appParams
        : processor.ovewritedPageParams || processor.root.routing.getCurrentParams();
    const dataStracted = await (0, extractParamWithEntryVar_1.default)({
        entryVar,
        params,
        evaluateEntryVar,
    });
    if (!dataStracted) {
        return undefined;
    }
    const valueFromParams = dataStracted.value;
    if ((0, valueIsNotUndefined_1.default)(valueFromParams)) {
        return valueFromParams;
    }
    let defaultEntryVar;
    if (entryVar.source === 'pageInputData') {
        const currentPageId = processor.root.routing.getCurrentPageId();
        if (currentPageId) {
            const currentPage = (_b = (_a = processor.root.getBuildOrders()) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b[currentPageId];
            defaultEntryVar = (_c = currentPage === null || currentPage === void 0 ? void 0 : currentPage.defaultInputData) === null || _c === void 0 ? void 0 : _c[dataStracted.dataPropName];
        }
    }
    else {
        const defaultEntries = (_d = processor.root.getBuildOrders()) === null || _d === void 0 ? void 0 : _d.defaultAppRuntimeData;
        if (defaultEntries) {
            defaultEntryVar = defaultEntries[dataStracted.dataPropName];
        }
    }
    if ((0, valueIsUndefined_1.default)(defaultEntryVar)) {
        return undefined;
    }
    return evaluateEntryVar(defaultEntryVar);
};
exports.default = entryVarEvaluatorContextInputData;
